import { Uniform } from './Uniform';

export class UniformBoolean extends Uniform {

    loadBoolean(value: boolean){
        if(this.location){
            this.gl.uniform1i(this.location, value ? 1 : 0);
        }
    }
}